<template>
  <div id="login">
    <v-layout row wrap class="pa-2">
      <v-flex xs12 v-if="!$route.query.r">
        <div
          class="pull-right"
          style="
            float: left;
            color: #10aa85;
            display: flex;
            align-items: center;
            font-weight: bold;
          "
          @click="
            sessionProfile.is_profile_completed
              ? $router.push('/profile-edit')
              : $router.push('/main-registration')
          "
        >
          <v-btn small icon light>
            <v-icon color="#10AA85">arrow_back</v-icon>
          </v-btn>
          <h2 class="fw400">Verifikasi</h2>
        </div>
      </v-flex>
      <v-flex class="pa-5">
        <v-layout class="center">
          <div class="box">
            <img
              src="@/assets/icon/registration/img_otp.png"
              alt="logo"
              style="margin-bottom: 10%"
            />
          </div>
        </v-layout>
        <v-layout>
          <v-flex xs12 text-xs-center>
            <span class="slogan">Masukkan nomor telepon</span><br />
            <span class="slogan">yang akan diverifikasi</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap style="padding: 15px">
          <v-flex md12 xs12 style="padding: 5px">
            <input
              autocomplete="off"
              type="text"
              @keydown="isNumber($event)"
              v-on:keyup.enter="submitPhoneNumberAuth()"
              :value="phoneNumber"
              @input="(e) => (phoneNumber = e.target.value)"
              id="voucher-text"
              placeholder="Nomor Telepon Aktif"
              style="
                background-color: #f5f5f5;
                height: 55px;
                padding: 8px;
                padding-left: 15px;
                border-radius: 30px;
                text-align: center;
                margin-bottom: 8px;
              "
            />
            <span
              style="color: #eb5757; margin-left: 14px"
              v-show="phoneNumber && phoneNumber.length <= 10 && !errorInvalidNumber"
              >Minimal 10 angka</span
            >
            <span style="color: #eb5757; margin-left: 14px" v-show="errorFirebase"
              >Proses pengiriman otp gagal</span
            >

            <span style="color: #eb5757; margin-left: 14px" v-show="errorInvalidNumber"
              >Nomor telepon yang dimasukkan tidak sah</span
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap style="position: absolute; bottom: 0; width: 100%">
      <v-flex xs12 style="margin-left: 20px; margin-right: 20px">
        <v-btn
          :disabled="
            phoneNumber === null ||
            phoneNumber === '' ||
            startProgress ||
            (phoneNumber && phoneNumber.length <= 10) ||
            errorInvalidNumber
          "
          id="recaptcha-container"
          color="#10aa85"
          :dark="startProgress"
          block
          round
          @click="submitPhoneNumberAuth()"
        >
          <!-- {{!startProgress && isRequired || countOTPattemp < 3 ? 'Minta Kode OTP' : !startProgress && !isRequired || countOTPattemp == 3  ? 'Simpan' : ''}} -->
          <span v-show="startProgress"></span>
          <span v-if="!startProgress" v-show="isRequired === true && !errTMR"
            >Minta Kode OTP</span
          >
          <span v-if="!startProgress" v-show="isRequired === false || errTMR"
            >Simpan</span
          >
          <v-progress-circular
            v-if="startProgress"
            indeterminate
            color="white"
          ></v-progress-circular>
        </v-btn>
      </v-flex>
      <v-snackbar
        v-model="notifErrorNumber"
        :bottom="true"
        :timeout="3000"
        color="black"
        dark
      >
        <p class="snackbar-p">Mohon masukkan data yang benar</p>
      </v-snackbar>
    </v-layout>

    <v-dialog
      v-model="otpview"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      id="confirmationelement"
    >
      <v-card style="background-color: #ffffff">
        <v-layout row wrap class="pa-2" v-if="!$route.query.r">
          <v-flex xs12 @click="otpview = false">
            <div
              class="pull-right"
              style="float: left; color: #10aa85; display: flex; align-items: center"
            >
              <v-btn small icon light>
                <v-icon color="#10AA85">arrow_back</v-icon>
              </v-btn>
              <h2 class="fw400">Verifikasi</h2>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="pa-2">
          <v-flex class="pa-5">
            <v-layout class="center">
              <div class="box">
                <img
                  src="@/assets/icon/registration/img_otp.png"
                  alt="logo-otp"
                  style="margin-bottom: 10%"
                />
              </div>
            </v-layout>
            <v-layout>
              <v-flex xs12 text-xs-center>
                <span
                  >Silahkan masukkan 6 digit angka kode verifikasi yang kami kirim melalui
                  SMS ke nomor <b>{{ phoneNumber }}</b></span
                >
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md12 xs12 style="padding: 5px">
                <input
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  v-on:keyup.enter="submitPhoneNumberAuthCode()"
                  v-model="otp"
                  id="voucher-text"
                  maxlength="6"
                  placeholder="6 Digit Kode OTP"
                  style="
                    background-color: #f5f5f5;
                    height: 55px;
                    padding: 8px;
                    padding-left: 15px;
                    border-radius: 30px;
                    text-align: center;
                    width: 100%;
                  "
                />
                <span style="color: #eb5757; margin-left: 14px" v-show="notifError"
                  >Kode OTP yang dimasukkan salah</span
                >
              </v-flex>
              <v-flex xs12 text-xs-center style="margin: 20px">
                <b
                  style="color: #00ade2; cursor: pointer"
                  v-show="countOTPattemp > 2 && date < 1"
                  @click="submitUnverified(phoneNumber)"
                  >Tidak Mendapatkan Kode OTP?</b
                >
                <b style="color: #00ade2" v-if="date > 0 && date === 60">01:00</b>
                <b style="color: #00ade2" v-if="date > 0 && date < 60">00:{{ date }}</b>
                <a
                  style="color: #00ade2; font-weight: bold; text-decoration: none"
                  @click="submitPhoneNumberAuth()"
                  v-if="date < 1 && countOTPattemp < 3"
                  >Kirim Ulang Kode</a
                >
              </v-flex>
              <v-flex xs12 style="display: flex; flex-flow: column; text-align: center">
                <span
                  >Salah nomor telepon ?
                  <a @click="otpview = false" style="color: #00ade2; font-weight: bold"
                    >Ubah Nomor</a
                  ></span
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap style="position: absolute; bottom: 0; width: 100%">
          <v-flex xs12 style="margin-left: 20px; margin-right: 20px">
            <v-btn
              :disabled="otp === null || otp === '' || startProgress"
              id="recaptcha-container"
              color="#10aa85"
              :dark="startProgress"
              block
              round
              @click="submitPhoneNumberAuthCode()"
            >
              {{ !startProgress ? "Verifikasi" : "" }}
              <v-progress-circular
                v-if="startProgress"
                indeterminate
                color="white"
              ></v-progress-circular>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
      <v-snackbar v-model="logininfo" :bottom="true" :timeout="4000" light color="danger">
        <p class="snackbar-p">{{ errormessage }}</p>
      </v-snackbar>
      <!-- <v-snackbar v-model="notifError" :bottom="true" :timeout="3000" color="black" dark>
            <p class="snackbar-p">Kode OTP yang dimasukkan salah</p>
        </v-snackbar> -->
    </v-dialog>
  </div>
</template>

<style>
#voucher-text {
  color: #10aa85;
  font-weight: bold;
  font-size: 16px;
  width: 100%;
}

#voucher-text:focus-visible {
  outline-color: #10aa85 !important;
}

.v-input.phonephone input[type="text"] {
  color: #10aa85 !important;
}

.v-input.phonephone {
  color: #10aa85 !important;
}

#login {
  min-height: 100vh;
  background-color: #ffffff;
  background-size: contain;
  background-position: center bottom;
}

.center {
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
}

.slogan {
  font-size: 18px;
  font-weight: 400;
}

.phntxt {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  width: 100%;
  margin-top: 20px;
}

.box {
  /* border: 1px gray dashed; */
  padding: 10px;
  display: flex;
  align-items: center;
  height: 100px;
  padding-top: 20px;
  margin-bottom: 30px;
}

.otp-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.otp-number-input {
  width: 40px;
  height: 50px;
  font-size: 20px;
  font-weight: bolder;
  text-align: center;
  border-bottom: 2px solid black;
  margin-right: 10px;
}

.otp-input {
  width: 40px;
  height: 50px;
  font-size: 20px;
  font-weight: bolder;
  text-align: center;
  border-bottom: 2px solid black;
  margin-right: 10px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.v-input.phonephone .v-input__control .v-input__slot {
  /* border-bottom:2px solid; */
  /* border-radius: 1px !important; */
}

.grecaptcha-badge {
  visibility: hidden !important;
}

::placeholder {
  color: #9c9c9c;
  font-weight: normal;
}
</style>

<script>
import OtpInput from "@bachdgvn/vue-otp-input";

export default {
  name: "the-loginpage",
  components: {
    "v-otp-input": OtpInput,
  },
  data() {
    return {
      sessionProfile: JSON.parse(sessionStorage.getItem("profile")),
      valid: true,
      otpview: false,
      email: null,
      password: null,
      logininfo: false,
      errormessage: null,
      startProgress: false,
      notifErrorNumber: false,
      countOTPattemp: 0,
      errorFirebase: false,
      errTMR: false,
      errorInvalidNumber: false,
      phoneRules: [
        (v) => !!v || "Nomor telepon wajib diisi",
        (v) => (v && v.length <= 13) || "Nomor telepon maksimal 15 digit",
        (v) =>
          !/[a-z`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi.test(v) ||
          "Nomor telepon tidak valid",
      ],
      otp: null,
      isDisabled: false,
      isError: false,
      shouldResetOTP: false,
      notifError: false,
      date: 30,
      phoneNumber: null,
      phn: null,
      pinVar: null,
      isRequired: true,
      profile: "",
      timerInterval: null,
    };
  },
  computed: {},
  watch: {
    otpview(to, from) {
      if (to) {
        clearInterval(this.timerInterval);
        this.date = 60;
        this.timer();
        this.otp = null;
      }
    },
    phoneNumber(to, from) {
      this.errorFirebase = false;
      this.errorInvalidNumber = false;
      this.phn = to;
      this.numberformat(to);
    },
    otp() {
      this.notifError = false;
      if (this.otp.length == 6) {
        this.submitPhoneNumberAuthCode();
      }
    },
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
  },
  mounted() {
    // this.$store.commit('setCompletionProfile', false)
    this.$store.dispatch("funcRealtimeMode").then((response) => {
      this.$nextTick(() => {
        this.isRequired = response.data.is_phone_verification_required;
        this.$forceUpdate();
      });
    });

    if (sessionStorage.getItem("profile")) {
      this.profile = JSON.parse(sessionStorage.getItem("profile"));
      sessionStorage.setItem(
        "IsPhoneVerified",
        JSON.stringify({
          phoneNumber: this.phoneNumber,
          status: false,
        })
      );
    } else {
      sessionStorage.setItem(
        "IsPhoneVerified",
        JSON.stringify({
          phoneNumber: null,
          status: false,
        })
      );
    }

    if (this.$route.query.e) {
      this.phoneNumber = "+62" + this.$route.query.e;
      this.$router.replace({
        query: "",
      });
    }
    try {
      firebase.initializeApp(this.$firebaseConfig);
    } catch (error) {
      this.errTMR = true;
    }

    var context = this;
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
        callback: function (response) {
          // context.submitPhoneNumberAuthCode()
        },
      }
    );
    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId;
    });

    // var UID = sessionStorage.UID;
    // if (this.$cookies.get('attemptotp-' + UID)) {
    //     this.countOTPattemp = this.$cookies.get('attemptotp-' + UID)
    // if (this.countOTPattemp > 0 && this.isRequired) this.otpview = true
    // else this.otpview = false
    // }
  },
  methods: {
    // otpFormat(){
    //     console.log('as')
    //     this.notifError = false
    //     if(this.otp.length == 6) this.submitPhoneNumberAuth()
    // },
    preventNav(event) {
      if (!this.otpview) return;
      event.preventDefault();
      event.returnValue = "";
    },
    isNumber(evt) {
      // const keysAllowed= ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      // const keyPressed = evt.key;
      // if (!keysAllowed.includes(keyPressed)) {
      //     evt.preventDefault()
      // }
      // evt = (evt) ? evt : window.event;
      // var charCode = (evt.which) ? evt.which : evt.keyCode;
      // if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
      //     evt.preventDefault();
      // } else {
      //     // setTimeout(() => {
      //         if (this.phoneNumber !== null) this.phoneNumber = '+62' + this.phn.substr(3)
      //         else this.phoneNumber = '+62' + this.phn
      //     // }, 100);
      //     // return true;
      // }
    },
    numberformat(v) {
      var regExp = /[a-zA-Z`~!@#$%^&*()_|\-=?;:'"\s,.<>\{\}\[\]\\\/]/g;
      var testString = v;

      if (regExp.test(testString)) {
        this.errorInvalidNumber = true;
      } else {
      }
      if (this.phoneNumber !== null) this.phoneNumber = "+62" + this.phn.substr(3);
      else this.phoneNumber = "+62" + this.phn;
    },
    filterKey(e) {
      const key = e.key;
      if (key === ".") {
        return e.preventDefault();
      }
      if (key === ",") {
        return e.preventDefault();
      }
      if (key === "e") {
        return e.preventDefault();
      }
      if (key === "-") {
        return e.preventDefault();
      }
      if (key === "+") {
        return e.preventDefault();
      }
    },
    onChangeOTP(otp) {
      this.otp = otp;
    },
    timer() {
      this.timerInterval = setInterval(() => {
        this.countOTPattemp = parseInt(
          this.$cookies.get("attemptotp-" + sessionStorage.UID)
        );
        if (this.date <= 0) {
          clearInterval(this.timerInterval);
        }
        var a = this.date;
        this.date = a - 1;
      }, 1000);
    },
    submitPhoneNumberAuth() {
      try {
        var UID = sessionStorage.UID;
        if (this.isRequired && !this.errTMR) {
          var cookiesAttempt = 0;
          if (this.$cookies.get("attemptotp-" + UID)) {
            cookiesAttempt = parseInt(this.$cookies.get("attemptotp-" + UID)) + 1;
            this.$cookies.set("attemptotp-" + UID, cookiesAttempt, "10MIN");
          } else {
            this.$cookies.set("attemptotp-" + UID, 0, "10MIN");
          }

          this.countOTPattemp = parseInt(this.$cookies.get("attemptotp-" + UID));
          if (this.phoneNumber.length > 9) {
            try {
              this.startProgress = true;
              var context = this;
              var phn = "";
              phn = context.phoneNumber;
              var appVerifier = window.recaptchaVerifier;
              firebase
                .auth()
                .signInWithPhoneNumber(phn, appVerifier)
                .then(function (confirmationResult) {
                  window.confirmationResult = !context.otpview
                    ? confirmationResult
                    : null;
                  context.otpview = true;
                  context.startProgress = false;
                  context.date = 60;
                  context.timer();
                })
                .catch(function (error) {
                  var err = JSON.parse(JSON.stringify(error));
                  if (err.code == "auth/too-many-requests") {
                    context.submitUnverified();
                    context.errTMR = true;
                  } else if (err.code == "auth/invalid-phone-number") {
                    context.errorInvalidNumber = true;
                  } else {
                    context.errorFirebase;
                  }
                  context.startProgress = false;
                });
            } catch (error) {
              context.startProgress = false;
              console.log(error);
              context.errTMR = true;
            }
          } else {
            this.notifErrorNumber = true;
          }
        } else {
          if (this.phoneNumber.length > 9) {
            this.submitUnverified();
          } else {
            this.notifErrorNumber = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    submitPhoneNumberAuthCode() {
      if (!this.otpview) return false;
      this.startProgress = true;
      var context = this;
      var code = this.otp + "";
      confirmationResult
        .confirm(code)
        .then(function (result) {
          context.startProgress = false;
          sessionStorage.setItem(
            "IsPhoneVerified",
            JSON.stringify({
              phoneNumber: context.phoneNumber,
              status: true,
            })
          );
          context.$store.commit("verifyPhoneMutation", {
            phoneNumber: context.phoneNumber,
            status: true,
          });
          context.profileUpdate();
        })
        .catch(function (error) {
          if (error) {
          }
          context.startProgress = false;
          context.notifError = true;
        });
    },
    profileUpdate() {
      let context = this;
      let prfl = JSON.parse(sessionStorage.getItem("profile"));
      var body = {
        phone_number: this.phoneNumber,
        // 'grade': prfl.grade,
        is_verified: true,
      };
      this.$store
        .dispatch("funcUpdatePhoneNumber", body)
        .then((response) => {
          sessionStorage.profile = JSON.stringify(response.data);
          if (context.$route.name === "change-number") {
            context.$router.push("/profile-edit");
          } else {
            context.$router.push("/");
          }
        })
        .catch(function () {});
    },
    submitUnverified() {
      var UID = sessionStorage.UID;
      let context = this;
      sessionStorage.setItem(
        "IsPhoneVerified",
        JSON.stringify({
          phoneNumber: context.phoneNumber,
          status: false,
        })
      );
      context.$store.commit("verifyPhoneMutation", {
        phoneNumber: context.phoneNumber,
        status: false,
      });

      let prfl = JSON.parse(sessionStorage.getItem("profile"));
      var body = {
        phone_number: context.phoneNumber,
        // 'grade': prfl.grade,
        is_verified: false,
      };
      context.$store
        .dispatch("funcUpdatePhoneNumber", body)
        .then((response) => {
          try {
            sessionStorage.profile = JSON.stringify(response.data);
            if (context.$route.name === "change-number") {
              context.$router.push("/profile-edit");
            } else {
              context.$cookies.set("attemptotp-" + UID, 0, "10MIN");
              context.$router.push("/main-registration");
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch(function () {});
    },
    checkProfile() {
      this.$router.push("/");
    },
  },
};
</script>
